'use client';


import React from 'react';
import { motion } from 'framer-motion';
import {
  FaAward, FaUsers, FaTools, FaCog, FaPaintBrush,
  FaIndustry, FaShieldAlt, FaBus, FaClock, FaCheckCircle, FaStar
} from 'react-icons/fa';

const BRAND_BLUE = "#3b82f6";
const DARK_SLATE = "#0f172a";

const ServicesIntro = () => {
  return (
    <section style={introSectionStyles}>

      <div style={containerStyles}>

        {/* --- SEO HEADER --- */}

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          style={{ textAlign: 'center', marginBottom: '50px' }}
        >
          <div style={badgeStyles}>
            <FaStar style={{ color: '#f59e0b', fontSize: '10px' }} />
            <span>ISO CERTIFIED CONSTRUCTION COMPANY QATAR</span>
          </div>

          <h2 style={titleStyles}>
            Comprehensive <span style={{ color: BRAND_BLUE }}>Construction & Manpower</span> Services in Qatar
          </h2>

          <p style={descriptionStyles}>
            Abraj Al Dhafna is your trusted partner for <strong>construction manpower supply in Qatar</strong>.
            As an ISO certified contractor, we provide skilled labor for construction in Doha,
            certified tradesmen, MEP specialists, and industrial services. Our reliable
            <strong> manpower Qatar</strong> includes electricians, plumbers, and welders available 24/7
            across Doha, Lusail, and The Pearl.
          </p>
        </motion.div>

        {/* --- MATCHING MINI-CARDS GRID --- */}
        <div style={seoGridStyles}>
          {[
            { icon: <FaUsers />, title: "Manpower Supply ", desc: "Fast and reliable mobilization of skilled, Semi-Skilled, and unskilled manpower for construction projects." },
            { icon: <FaTools />, title: "Skilled Labor", desc: "Certified tradesmen including masons, carpenters, steel fixers, Brush Painters, Scaffolders, and more." },
            { icon: <FaCog />, title: "MEP Specialists", desc: "Qualified mechanical, electrical, and plumbing technicians for site and maintenance works." },
            { icon: <FaPaintBrush />, title: "Painting Specialists", desc: "Professional industrial and commercial painting with high-quality finishes." },
            { icon: <FaIndustry />, title: "Epoxy & Concrete Works", desc: "Epoxy flooring systems, concrete repair, and surface treatment services." },
            { icon: <FaShieldAlt />, title: "Waterproofing Services", desc: "Industrial-grade waterproofing solutions for roofs, basements, and structures." },
            { icon: <FaClock />, title: "24/7 Availability", desc: "Round-the-clock manpower and technical support for urgent site requirements." },
          ].map((item, idx) => (
            <motion.div
              key={idx}
              whileHover={{ y: -5 }}
              style={miniCardStyles}
            >
              <div style={miniIconWrapper}>{item.icon}</div>
              <div style={{ textAlign: 'left' }}>
                <h4 style={miniTitleStyles}>{item.title}</h4>
                <p style={miniDescStyles}>{item.desc}</p>
              </div>
              {/* Accent Line matching the main cards */}
              <div style={miniAccentLine} />
            </motion.div>
          ))}
        </div>

        {/* --- STATS BAR (Matches rest of design) --- */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.2 }}
          viewport={{ once: true }}
          style={statsContainerStyles}
        >
          {[
            { num: '10+', label: 'Years Of Industry Experience' },
            { num: '100+', label: 'Completed Projects' },
            { num: '350+', label: 'Skilled workforce' },
            { num: '50+', label: 'Satisfied Clients' }
          ].map((stat, i) => (
            <div key={i} style={statItemStyles}>
              <div style={statNumStyles}>{stat.num}</div>
              <div style={statLabelStyles}>{stat.label}</div>
            </div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

// --- STYLES ---

const introSectionStyles = {
  padding: 'clamp(50px, 8vw, 80px) 0',
  background: '#f8fafc', // Same as your main background
  width: '100%',
  overflow: 'hidden'
};

const containerStyles = {
  maxWidth: '1240px',
  margin: '0 auto',
  padding: '0 24px',
};

const badgeStyles = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: '8px',
  background: '#fff',
  padding: '6px 16px',
  borderRadius: '50px',
  boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
  fontSize: '11px',
  fontWeight: 800,
  letterSpacing: '0.5px',
  color: BRAND_BLUE,
  marginBottom: '20px',
  border: '1px solid #f1f5f9'
};

const titleStyles = {
  fontSize: 'clamp(1.8rem, 4vw, 2.5rem)',
  fontWeight: 900,
  color: DARK_SLATE,
  lineHeight: 1.2,
  marginBottom: '20px'
};

const descriptionStyles = {
  fontSize: 'clamp(14px, 2vw, 15px)',
  color: '#64748b',
  maxWidth: '800px',
  margin: '0 auto 40px',
  lineHeight: 1.6
};

// --- MINI CARD STYLES (Simlar to Service Cards) ---

const seoGridStyles = {
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fill, minmax(min(100%, 270px), 1fr))',
  gap: '20px',
  marginBottom: '50px'
};

const miniCardStyles = {
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  gap: '15px',
  padding: '20px',
  background: '#ffffff',
  borderRadius: '20px',
  border: '1px solid #f1f5f9',
  boxShadow: '0 4px 10px rgba(0,0,0,0.02)',
  transition: 'all 0.3s ease',
  overflow: 'hidden'
};

const miniIconWrapper = {
  width: '45px',
  height: '45px',
  borderRadius: '12px',
  background: `${BRAND_BLUE}10`,
  color: BRAND_BLUE,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: '1.2rem',
  flexShrink: 0
};

const miniTitleStyles = {
  fontSize: '14px',
  fontWeight: 800,
  color: DARK_SLATE,
  margin: 0,
  lineHeight: '1.2'
};

const miniDescStyles = {
  fontSize: '12px',
  color: '#64748b',
  margin: '4px 0 0'
};

const miniAccentLine = {
  position: 'absolute',
  bottom: 0,
  left: 0,
  width: '100%',
  height: '3px',
  background: BRAND_BLUE,
  opacity: 0.1
};

// --- STATS BAR STYLES ---

const statsContainerStyles = {
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))',
  gap: '20px',
  background: DARK_SLATE,
  padding: '40px 20px',
  borderRadius: '24px',
  boxShadow: '0 20px 40px rgba(0,0,0,0.1)'
};

const statItemStyles = {
  textAlign: 'center',
  borderRight: '1px solid rgba(255,255,255,0.1)',
};

// Remove border from last item on desktop via JS logic if needed, 
// but standard grid handles it well visually.

const statNumStyles = {
  fontSize: 'clamp(28px, 4vw, 36px)',
  fontWeight: 900,
  color: '#ffffff',
  marginBottom: '4px'
};

const statLabelStyles = {
  fontSize: '11px',
  textTransform: 'uppercase',
  fontWeight: 700,
  color: BRAND_BLUE,
  letterSpacing: '1px',
  opacity: 0.9
};

export default ServicesIntro;